import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ItemProfitibilityReportStoreService } from '../item-profitibility-report-store.service';
import { mergeMap, startWith } from 'rxjs/operators';
import { of } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { AddCurrencyPrefixDirective } from '../../../shared/directives/add-currency-prefix.directive';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';

@Component({
    selector: 'app-controls-form',
    templateUrl: './controls-form.component.html',
    standalone: true,
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, NgIf, NgFor, MatPrefix, AddCurrencyPrefixDirective, MatInput, MatButton, AsyncPipe]
})
export class ControlsFormComponent {
  form = new FormGroup({
    filterBy: new FormControl<string>(null),
    filterId: new FormControl<number>(null),
    labourCost: new FormControl<number>(null)
  });

  options$ = this.form.controls.filterBy.valueChanges.pipe(
    startWith(null),
    mergeMap((filterBy) => {
      switch (filterBy) {
        case 'product':
          return this.store.products$;
        case 'category':
          return this.store.categories$;
        default:
          return of([]);
      }
    })
  );

  constructor(private store: ItemProfitibilityReportStoreService) {}

  generateReport() {
    this.store.getResults(this.form.value);
  }
}
